import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { ItemsTab } from '@b2b/features/cart/utilities/checkout-tabs.model';

@Component({
  selector: 'checkout-tabs',
  imports: [CommonModule, RouterModule],
  templateUrl: './checkout-tabs.component.html',
  styleUrls: ['./checkout-tabs.component.scss'],
})
export class CheckoutTabsComponent {
  @Input() items?: ItemsTab[];

  private readonly router = inject(Router);

  navigate(url?: string) {
    if (url) {
      this.router.navigate([url]);
    }
  }
}
